import {
  BaseProcess,
  BaseProcessMetadata,
  BaseState,
  COMMON_ACTION_TYPES,
  Connection,
  GenericGraph
} from '@common/types';

import { fetchJobRunList } from '../../../data/apis/api';
import { ExtractXHRResponseDataType } from '../../../data/util';
import { ConnectorEvent, ObservationType } from '../query';
import { ConnectorEventTypes, ProjectEventTypes } from '../types';

export interface ObservationMetadata {
  isLoadingMoreData?: boolean;
  hasFabric?: boolean;
  fabricId: string;
  startDateTo: Date;
  startDateFrom?: number | string;
}

export interface DQObservationMetadata {
  observations: ObservationType[];
  selectedStatus?: string;
  dates: string[];
  eventType: ProjectEventTypes;
}

export interface ConnectorObservationMetadata {
  selectedConnectorName: string;
  events: ConnectorEvent[];
  eventType: ConnectorEventTypes;
}

export type RunType = ExtractXHRResponseDataType<typeof fetchJobRunList>;

export const ResetObservationKeyWord = 'RESET';

export type ObservationGraph = GenericGraph<
  DQObservationMetadata & ConnectorEvent & ObservationMetadata,
  BaseProcessMetadata,
  BaseProcess<BaseProcessMetadata>,
  Connection
>;

export type ObservationState = BaseState<ObservationGraph, { project?: { name: string; id: string } }> & {
  dataQuality: DQObservationMetadata;
  connectorObservation: ConnectorObservationMetadata;
  observationMetadata: ObservationMetadata;
};

export enum actionTypes {
  validationError = 'validationError',
  setProject = 'setProject',
  setProjectObservations = 'setProjectObservations',
  setConnectorEvents = 'setConnectorEvents',
  setObservationDate = 'setObservationDate',
  setProjectEventType = 'setProjectEventType',
  setConnetorEventType = 'setConnetorEventType',
  changeFabric = 'changeFabric',
  setIsLoadingMoreData = 'setIsLoadingMoreData',
  setStatus = 'setStatus',
  setSelectedConnectorName = 'setSelectedConnectorName'
}

type DQ_ACTION =
  | {
      type: actionTypes.setIsLoadingMoreData;
      payload: boolean;
    }
  | {
      type: actionTypes.setStatus;
      payload: { status?: string };
    }
  | {
      type: actionTypes.validationError;
      payload: string;
    }
  | {
      type: actionTypes.setProjectObservations;
      payload: { observations: ObservationType[]; loadMore: boolean };
    }
  | {
      type: actionTypes.changeFabric;
      payload: string;
    }
  | {
      type: actionTypes.setObservationDate;
      payload?: number | string;
    }
  | {
      type: actionTypes.setProjectEventType;
      payload: { eventType: ProjectEventTypes };
    }
  | {
      type: actionTypes.setProject;
      payload: { project?: { id: string; name: string }; fabricId: string; event?: ProjectEventTypes };
    }
  | {
      type: actionTypes.setConnectorEvents;
      payload: { events: ConnectorEvent[] };
    }
  | {
      type: actionTypes.setConnetorEventType;
      payload: { eventType: ConnectorEventTypes };
    }
  | {
      type: actionTypes.setSelectedConnectorName;
      payload: { connectorName: string };
    };

export type DQ_IDE_ACTION_TYPES = DQ_ACTION | COMMON_ACTION_TYPES<ObservationGraph, DQObservationMetadata>;
